module.exports = {template: '<svg width="36" height="45" viewBox="0 0 36 45" xmlns="http://www.w3.org/2000/svg"><path d="M17 9.5l-17 17 17.607 17.607 17.5-17.5L26 17.5V0l-9 9.5z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_single_quote_blue.svg
// module id = 1108
// module chunks = 1 32 34